import { render, staticRenderFns } from "./RoundModalRound.vue?vue&type=template&id=1dc61530&"
import script from "./RoundModalRound.vue?vue&type=script&lang=ts&"
export * from "./RoundModalRound.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports